import { PageTemplate } from "components";
import { useParams } from "react-router-dom";
import { Toast } from "components";
import FromNew from "components/Form/FormNew";
import json from "utils/json";
import { createPayment } from "Services/Reporting";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useHistory } from "react-router";
import { getBranchesByVendorId } from "Services/Branches";
import { removeCamma } from "utils/helpers";
import { useMemo, useState } from "react";
import useLocalStorageState from "hooks/useLocalStorageState";

const AddNewPayment = () => {
    const history = useHistory();
    const { vendorID, periodID } = useParams<{
        vendorID: string;
        periodID: string;
    }>();
    const [financialPeriodDate] = useLocalStorageState("financialPeriodDate");
    const [date, setDate] = useState(financialPeriodDate);
    const [values, setValues] = useState({
        amount: "",
        branch_id: null,
        date: null,
        reason: "",
        period_id: null,
    });
    const initialToast = {
        status: "success",
        show: false,
        message: "",
    };
    const [toast, setToast] = useState(initialToast);
    const { mutate: createPaymentReq, isLoading } = useMutation(
        ["createPayment"],
        createPayment,
        {
            onSuccess: () => {
                setToast({
                    status: "success",
                    show: true,
                    message: "پرداختی جدید با موفقیت ایجاد شد.",
                });
                history.goBack();
            },
        }
    );
    const { data } = useQuery(
        ["branches", vendorID],
        () => getBranchesByVendorId(+vendorID),
        { enabled: !!vendorID }
    );
    const branchList = useMemo(() => data?.data?.data || [], [data]);
    const jsonPayment = useMemo(() => {
        const jsonObj: { [key: string]: number } = {};
        branchList.forEach((item) => {
            jsonObj[item.title] = item.id;
        });
        return JSON.stringify(jsonObj);
    }, [branchList]);
    json["payment"].create[0].inputs[0].data = jsonPayment;
    const submitData = (data: any) => {
        const body = {
            ...data,
            period_id: Number(periodID),
            date: date as string,
            branch_id: Number(data.branch_id),
            amount: removeCamma(data.amount),
            reason: data.reason.trim(),
        };
        const validationInputKeys = ["branch_id", "reason", "amount"];
        const dataFieldsName = ["نام شعبه", "علت", "مبلغ"];
        const hasNotValidateData = validationInputKeys.map((item, index) => {
            if (body[item] == 0 || body[item] === "") {
                setTimeout(() => setToast(initialToast), 1000);
                return setToast({
                    status: "danger",
                    show: true,
                    message: `لطفا ${dataFieldsName[index]} را وارد کنید.`,
                });
            } else {
                return true;
            }
        });
        if (!hasNotValidateData.includes(undefined)) {
            createPaymentReq(body);
        }
    };
    const handleChangeForm = (name: string, value: any) => {
        if(name === "date") {
            setDate(value);
        } else {
            setValues((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    return (
        <>
            <PageTemplate
                isNewBackground
                groupName="گزارشات"
                title={"دوره مالی"}
                listOfTitles={["پرداخت‌ها", "اضافه کردن پرداختی جدید"]}
            >
                <Toast className={""} isShow={false} title={""} />
                <FromNew
                    className="page-template-form-container"
                    formData={json["payment"].create}
                    formTitle={"اضافه کردن پرداختی جدید"}
                    updateData={values}
                    updateLoading={isLoading}
                    getFormData={(data) => submitData(data)}
                    updateFormData={(data) => submitData(data)}
                    handleChange={(name, value) => {
                        handleChangeForm(name, value);
                    }}
                />
            </PageTemplate>
            <Toast
                className={toast.status}
                isShow={toast.show}
                title={toast.message}
            />
        </>
    );
};

export default AddNewPayment;
